const NUMSEATS_KEY = 'numSeats';

/**
 * parse data for Reserved Seats
 */
export default function getSeatsReserved(eventEntity: any): number {
    let numSeats = 0;

    if (eventEntity[NUMSEATS_KEY] && eventEntity[NUMSEATS_KEY] > 0) {
        numSeats = parseInt(eventEntity[NUMSEATS_KEY], 10) - 1;
    }

    return numSeats;
}
